import { ClientConfig, PublicHoliday } from '@openmirror/shared';

type BusinessHoursFeatureConfig = ClientConfig & {
  afterHoursPrompt: string;
  publicHolidays: PublicHoliday[];
};

const UNSUPPORTED_SETTINGS_MESSAGE =
  'The server did not return after-hours settings. Update the Dashboard API before editing these settings.';

export const requireBusinessHoursConfig = (config?: ClientConfig): BusinessHoursFeatureConfig => {
  if (typeof config?.afterHoursPrompt !== 'string' || !Array.isArray(config.publicHolidays)) {
    throw new Error(UNSUPPORTED_SETTINGS_MESSAGE);
  }
  if (!config.publicHolidays.every(holiday =>
    holiday !== null && typeof holiday === 'object' &&
    typeof holiday.date === 'string' && typeof holiday.name === 'string'
  )) {
    throw new Error('The server returned invalid public holiday settings. Please contact support.');
  }
  return { ...config, afterHoursPrompt: config.afterHoursPrompt, publicHolidays: config.publicHolidays };
};

export const verifyBusinessHoursSave = (
  config: ClientConfig | undefined,
  expected: { afterHoursPrompt: string; publicHolidays: PublicHoliday[] },
): void => {
  const saved = requireBusinessHoursConfig(config);
  const holidaysMatch = saved.publicHolidays.length === expected.publicHolidays.length &&
    expected.publicHolidays.every(holiday => saved.publicHolidays.some(candidate =>
      candidate.date === holiday.date && candidate.name === holiday.name.trim()
    ));
  if (saved.afterHoursPrompt !== expected.afterHoursPrompt.trim() || !holidaysMatch) {
    throw new Error('The server did not confirm your after-hours prompt and holidays. Your edits are still here; please contact support before closing.');
  }
};
